import gql from 'graphql-tag'

import { STATEMENT_PARTS, USER_PARTS } from './fragments'
import apolloClient from '@/vendor/apollo'

export function getOkrModifyStatus (id) {
  return apolloClient.query({
    query: gql`
      query GetOkr ($id: Int!) {
        okrlist(id: $id) {
          id: _id
          is_modified
          is_published
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.okrlist)
}

export function getPublishedOkr (id) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetOkr ($id: Int!, $isPublished: Boolean = true) {
        okrlist(id: $id) {
          id: _id
          is_published
          cycle_id {
            id: _id
            name
          }
          approval_status
          organizational_skills
          personal_development
          organizational_skills_self_review
          personal_development_self_review
          objectives (published: $isPublished) {
            id: _id
            content: published_content
            mention_user_ids
            progress
            comment_count
            statement_id {
              id: _id
            }
            output_desc
            weight
            is_financial
            performance_is_hide
            performance_objective
            performance_objective_self_review #绩效自评
            key_results {
              id: _id
              content
              mention_user_ids
              #weight
              progress
              start_day
              finish_day
              indicator
              collaborators
              #confidence_index
              comment_count
              state_id {
                id: _id
              }
              statement_id {
                id: _id
              }
              link_to_statements {
                ...StatementParts
              }
              linked_from_statements {
                ...StatementParts
              }
            }
            link_to_statements {
              ...StatementParts
            }
            linked_from_statements {
              ...StatementParts
            }
            review_summary
            review_next_action
            review_attachment_ids {
              id: _id
              name
            }
            reviews {
              id: _id
              progress_achievement
              decision_issue
              review_attachments
              review_flag
            }
          }
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.okrlist)
}

export function getPersonalObjective (id) {
  return apolloClient.query({
    query: gql`
      query GetOkr ($id: Int!) {
        okrlist(id: $id) {
          organizational_skills
          personal_development
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.okrlist)
}

export function getMyOkr (id) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetOkr ($id: Int!) {
        okrlist(id: $id) {
          id: _id
          is_published
          is_modified
          cycle_id {
            id: _id
            name
          }
          approval_status
          organizational_skills
          personal_development
          organizational_skills_self_review
          personal_development_self_review
          objectives {
            id: _id
            content
            mention_user_ids
            progress
            comment_count
            statement_id {
              id: _id
            }
            output_desc
            weight
            is_financial
            performance_is_hide
            performance_objective
            performance_objective_self_review #绩效自评
            key_results {
              id: _id
              content
              mention_user_ids
              #weight
              progress
              start_day
              finish_day
              indicator
              collaborators
              #confidence_index
              comment_count
              state_id {
                id: _id
              }
              statement_id {
                id: _id
              }
              link_to_statements {
                ...StatementParts
              }
              linked_from_statements {
                ...StatementParts
              }
            }
            link_to_statements {
              ...StatementParts
            }
            linked_from_statements {
              ...StatementParts
            }
            review_summary
            review_mention_uids
            review_next_action
            review_next_mention_uids
            review_attachment_ids {
              id: _id
              name
            }
            reviews {
              id: _id
              progress_achievement
              decision_issue
              review_attachments
              review_flag
            }
          }
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.okrlist)
}

export function getNotifyUsers (okrListId) {
  return apolloClient.query({
    query: gql`
      query GetNotifyUsers ($id: Int!) {
        okrlist (id: $id) {
          notify_users
        }
      }
    `,
    variables: {
      id: okrListId
    }
  }).then(res => res.data.okrlist.notifyUsers)
}

export function getMyObjective (id, withKeyResults) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetMyObjective ($id: Int!, $withKeyResults: Boolean = false) {
        objective(id: $id) {
          id: _id
          content
          mention_user_ids
          progress
          comment_count
          statement_id {
            id: _id
          }
          weight
          is_financial
          performance_is_hide
          performance_objective
          performance_objective_self_review
          link_to_statements {
            ...StatementParts
          }
          linked_from_statements {
            ...StatementParts
          }
          key_results @include(if: $withKeyResults) {
            id: _id
            content
            mention_user_ids
            #weight
            progress
            start_day
            finish_day
            indicator
            collaborators
            #confidence_index
            comment_count
            state_id {
              id: _id
            }
            statement_id {
              id: _id
            }
            link_to_statements {
              ...StatementParts
            }
            linked_from_statements {
              ...StatementParts
            }
          }
          review_summary
          review_mention_uids
          review_next_action
          review_next_mention_uids
          review_attachment_ids {
            id: _id
            name
          }
          reviews {
            id: _id
            progress_achievement
            decision_issue
            review_attachments
            review_flag
          }
        }
      }
    `,
    variables: {
      id,
      withKeyResults
    }
  }).then(res => res.data.objective)
}

export function getPublishedObjective (id) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetMyObjective ($id: Int!) {
        objective(id: $id) {
          id: _id
          content: published_content
          mention_user_ids
          progress
          comment_count
          statement_id {
            id: _id
          }
          weight
          is_financial
          performance_is_hide
          performance_objective
          performance_objective_self_review
          link_to_statements {
            ...StatementParts
          }
          linked_from_statements {
            ...StatementParts
          }
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.objective)
}

export function getMyKeyResult (id) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetMyKeyResult ($id: Int!) {
        key_result(id: $id) {
          id: _id
          content
          mention_user_ids
          progress
          #weight
          start_day
          finish_day
          indicator
          comment_count
          state_id {
            id: _id
          }
          statement_id {
            id: _id
          }
          link_to_statements {
            ...StatementParts
          }
          linked_from_statements {
            ...StatementParts
          }
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.keyResult)
}

export function getPublishedKeyResult (id) {
  return apolloClient.query({
    query: gql`
      ${USER_PARTS}
      ${STATEMENT_PARTS}
      query GetPublishedKeyResult ($id: Int!) {
        key_result(id: $id) {
          id: _id
          content: published_content
          mention_user_ids
          progress
          start_day
          finish_day
          indicator
          comment_count
          state_id {
            id: _id
          }
          statement_id {
            id: _id
          }
          link_to_statements {
            ...StatementParts
          }
          linked_from_statements {
            ...StatementParts
          }
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.keyResult)
}

export function reorderObjective (objectiveIds) {
  return apolloClient.mutate({
    mutation: gql`
      mutation ReorderObjective ($ids: [Int!]) {
        result: resequence(model: "okr.objective", ids: $ids)
      }
    `,
    variables: {
      ids: objectiveIds
    }
  })
}

export function reorderKeyResult (keyResultIds) {
  return apolloClient.mutate({
    mutation: gql`
      mutation ReorderKeyResult ($ids: [Int!]) {
        result: resequence(model: "okr.keyresult", ids: $ids)
      }
    `,
    variables: {
      ids: keyResultIds
    }
  })
}

export function getObjectives (ids) {
  return apolloClient.query({
    query: gql`
      query getObjectives ($ids: [Int]!) {
        objectives (ids: $ids) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          node {
            id: _id
          content
          mention_user_ids
          progress
          comment_count
          statement_id {
            id: _id
          }
          weight
          is_financial
          performance_is_hide
          performance_objective
          performance_objective_self_review
          review_summary
          review_mention_uids
          review_next_action
          review_next_mention_uids
          review_attachment_ids {
            id: _id
            name
          }
          reviews {
            id: _id
            progress_achievement
            decision_issue
            review_attachments
            review_flag
          }
          }
        }
      }
      }
    `,
    variables: {
      ids
    }
  }).then(res => res.data.objectives.edges.map(item => item.node))
}
